import Stoor from 'stoor';

const storage = new Stoor({ namespace: 'digs' });

export default storage;
